import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Stethoscope, Lock } from "lucide-react";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { useAuth } from "../context/AuthContext";
import { formatApiErrorDetail } from "../lib/api";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center px-4" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <div className="flex items-center justify-center gap-2 mb-8">
          <span className="w-10 h-10 rounded-full bg-primary flex items-center justify-center">
            <Stethoscope className="w-5 h-5 text-white" />
          </span>
          <span className="font-heading font-semibold text-xl text-slate-900">Doktor<span className="text-emerald-600">Ke</span>Rumah</span>
        </div>
        <form onSubmit={submit} className="bg-white rounded-2xl border border-slate-200 p-8 shadow-sm space-y-5">
          <div className="flex items-center gap-2 mb-2">
            <Lock className="w-5 h-5 text-primary" />
            <h1 className="font-heading text-xl font-semibold text-slate-900">Admin Login</h1>
          </div>
          {error && <p data-testid="login-error" className="text-sm text-red-600 bg-red-50 rounded-lg px-4 py-3">{error}</p>}
          <div>
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" required data-testid="login-email-input" value={email} onChange={(e) => setEmail(e.target.value)} className="mt-2" />
          </div>
          <div>
            <Label htmlFor="password">Password</Label>
            <Input id="password" type="password" required data-testid="login-password-input" value={password} onChange={(e) => setPassword(e.target.value)} className="mt-2" />
          </div>
          <Button type="submit" disabled={loading} data-testid="login-submit-btn" className="w-full rounded-full h-11">
            {loading ? "Signing in..." : "Sign In"}
          </Button>
        </form>
      </div>
    </div>
  );
}
